module.exports = __webpack_public_path__ + "img/hero-water-01.2020ecab.png";